import { render, staticRenderFns } from "./Interview2.vue?vue&type=template&id=6cbaa1b2&scoped=true&"
import script from "./Interview2.vue?vue&type=script&lang=js&"
export * from "./Interview2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbaa1b2",
  null
  
)

export default component.exports